import { render, staticRenderFns } from "./manualCompany.vue?vue&type=template&id=5b7d5a4e&scoped=true&"
import script from "./manualCompany.vue?vue&type=script&lang=js&"
export * from "./manualCompany.vue?vue&type=script&lang=js&"
import style0 from "./manualCompany.vue?vue&type=style&index=0&id=5b7d5a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d5a4e",
  null
  
)

export default component.exports